import Alpine from 'alpinejs'
import collapse from '@alpinejs/collapse'
import intersect from '@alpinejs/intersect'
import persist from '@alpinejs/persist'
import Clipboard from "@ryangjchandler/alpine-clipboard"
Alpine.plugin(Clipboard)
Alpine.plugin(intersect)
Alpine.plugin(collapse)
Alpine.plugin(persist)
window.Alpine = Alpine
Alpine.start()